<template>
  <div id="menu-bg">
    <home
      :backgroundCustom="color"
      :title="title"
      :description="description"
      :link="link"
    />
    <menu-content
      :content="content"
      :index="index + 1"
      v-for="(content, index) in contents"
      :progress="progress"
      :key="index"
      class="ml-0 mr-0 mt-5 pb-5"
      @routePreview="routePreview"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Home from "./Home";
import MenuContent from "../../components/template/CPR/menu/index";
export default {
  name: "Menu",
  components: {
    Home,
    MenuContent,
    link: "",
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      color:
        "linear-gradient(180deg, rgba(169,241,223,1) 0%, rgba(56,173,174,1) 100%);",
      contents: [],
      title: [],
      description: [],
      lang: "th",
      courseCode: "",
      baseUrl: process.env.VUE_APP_URL_SOUND,
      progress: [],
    };
  },
  created() {
    this.courseCode = this.$store.getters["necessary/getLerningCourse"]._id;
  },
  mounted() {
    let body = {};
    body.code = this.courseCode;
    body.templateCode = "CPRMENU";
    this.$store.dispatch("template/fetchContent", body);
  },
  computed: {
    ...mapGetters({
      getContent: "template/getTemplateContent",
      getCourseProgress: "courses/getCourseChapterAndProgress",
    }),
  },
  watch: {
    getCourseProgress: function (val) {
      var currActive = '';
      var countComplete = 0;
      this.progress = val.template;
      for (var i = 0; i < this.progress.length; i++) {
        if(this.progress[i].lock == false){
          currActive = this.progress[i].code
        }
      }//loop
      this.link = currActive;
    },
    getContent: function (val) {
      this.contents = [];
      val.content.item.forEach((element) => {
        this.contents.push({
          name: this.$helpers.translate(element.message, this.lang),
          index: element.position,
          image: this.baseUrl + "/cpr/Image/" + element.image,
          text: this.$helpers.translate(element.message, this.lang).split(" "),
          button: element.button,
        });
      });
      this.title = val.title;
      this.description = val.description;
      this.$store.dispatch(
        "courses/fetchCourseChapterAndProgress",
        this.courseCode
      );
    },
  },
  methods: {
    enterCourse() {
      //this.$router.push('thetruthuntold')
    },
    routePreview(action) {
      this.$router.push("CPR/preview/" + action);
    },
  },
};
</script>

<style scoped>
@import "../../assets/scss/CPR/style.scss";
#menu-bg {
  background: linear-gradient(
    180deg,
    rgba(56, 173, 174, 1) 0%,
    rgba(205, 41, 90, 1) 100%
  );
}
</style>